import { ArrowL, ArrowR, Nav } from './styles';

import Link from 'next/link';
const Pagination = ({ currentPage = 1, numPages = 1 }) => {
  if (numPages <= 1) {
    return (
      <Nav role="navigation" aria-label="pagination">
        <ul />
      </Nav>
    );
  }

  const hasNext = currentPage < numPages;
  const hasPrev = currentPage > 1;
  const nextPage = `/blog/page/${currentPage + 1}`;
  const prevPage = currentPage === 2 ? `/blog` : `/blog/page/${currentPage - 1}`;

  return (
    <Nav role="navigation" aria-label="pagination">
      <ul>
        {hasPrev && (
          <li>
            <Link href={prevPage} aria-label="Previous Page" aria-current={false}>
              <ArrowL size={16} />
              Prev
            </Link>
          </li>
        )}
        {Array(numPages)
          .fill(1)
          .map((x, i) => {
            const page = i + 1;
            const isCurrent = page === currentPage;
            return (
              <li key={page}>
                <Link
                  href={page > 1 ? `/blog/page/${page}` : `/blog`}
                  className={isCurrent ? 'active' : ''}
                  aria-label={isCurrent ? `Current Page, Page ${page}` : `Page ${page}`}
                  aria-current={isCurrent}
                >
                  {page}
                </Link>
              </li>
            );
          })}
        {hasNext && (
          <li>
            <Link href={nextPage} aria-label="Next Page" aria-current={false}>
              Next
              <ArrowR size={16} />
            </Link>
          </li>
        )}
      </ul>
    </Nav>
  );
};

export default Pagination;
